<ion-content>
  <!-- Specify Teammates and Customers Settings Card MOVED TO TOP -->
  <ion-card class="outline-card" *ngIf="channel">
    <ion-card-header>
      <div class="flex-space-between">
        <div>
          <ion-card-title class="card-title-text">
            Channel Teammates & Customers
            <a
              href="https://docs.unthread.io/conversations/convo-track#customers-vs-agents"
              target="_blank"
              style="margin-left: 5px; font-size: 0.9em; vertical-align: middle"
            >
              <ion-icon
                name="book-outline"
                aria-label="Documentation link"
              ></ion-icon>
            </a>
          </ion-card-title>
          <ion-card-subtitle class="card-subtitle-text"
            >Customers are those who can create tickets, and teammates are those
            who can respond and be assigned tickets.<br />Project settings
            determine teammates based on their role as an
            agent.</ion-card-subtitle
          >
        </div>
        <ion-button
          color="dark"
          size="small"
          (click)="isOverridesExpanded = !isOverridesExpanded"
          aria-label="Toggle override settings visibility"
        >
          Manage Role Overrides
          <ion-icon
            [name]="
              isOverridesExpanded
                ? 'chevron-up-outline'
                : 'chevron-down-outline'
            "
            slot="icon-only"
            class="button-icon padded-icon"
          ></ion-icon>
        </ion-button>
      </div>
    </ion-card-header>
    <ion-card-content *ngIf="isOverridesExpanded">
      <ion-list lines="none" class="transparent-bg">
        <!-- Allowlist Section -->
        <ion-item-group>
          <ion-item-divider color="light">
            <ion-label>Override Teammate List</ion-label>
            <ion-toggle
              slot="end"
              [(ngModel)]="overrideAllowlist"
              (ionChange)="onAllowlistOverrideChange()"
              aria-label="Enable channel-specific teammate allowlist"
            ></ion-toggle>
          </ion-item-divider>
          <div *ngIf="overrideAllowlist">
            <ion-item
              lines="none"
              class="description-item ion-text-wrap"
              text-wrap
            >
              <ion-label text-wrap>
                When enabled, only users/groups added to the list below will be
                treated as internal teammates in this channel (overriding
                project defaults). If this list is empty,
                <strong>no one</strong> is considered a teammate by default in
                this channel.
              </ion-label>
            </ion-item>
            <div class="chip-container">
              <ion-chip
                mode="ios"
                color="dark"
                class="add-chip"
                ngxTippy
                [hidden]="internalEntityOverrides?.allowlist?.length > 0"
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content:
                    'Unless users are specified, no one is considered a teammate'
                }"
              >
                <ion-label>Overriding all members as teammates</ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                color="primary"
                class="entity-chip"
                *ngFor="
                  let entity of internalEntityOverrides?.allowlist || [];
                  let i = index
                "
              >
                <ion-label> {{ getEntityName(entity) }} </ion-label>
                <ion-icon
                  name="close-circle"
                  (click)="removeFromAllowlist(i)"
                  aria-label="Remove from allowlist"
                ></ion-icon>
              </ion-chip>
              <ion-chip
                mode="ios"
                outline="true"
                color="primary"
                (click)="addToAllowlist($event)"
                class="add-chip"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Add user or group to always treat as teammate'
                }"
              >
                <ion-icon name="add-circle-outline" slot="start"></ion-icon>
                <ion-label>Add specific users or groups</ion-label>
              </ion-chip>
            </div>
          </div>
        </ion-item-group>

        <!-- Blocklist Section -->
        <ion-item-group style="margin-top: 16px">
          <ion-item-divider color="light">
            <ion-label>Override Customer List</ion-label>
            <ion-toggle
              slot="end"
              [(ngModel)]="overrideBlocklist"
              (ionChange)="onBlocklistOverrideChange()"
              aria-label="Enable channel-specific customer blocklist"
            ></ion-toggle>
          </ion-item-divider>
          <div *ngIf="overrideBlocklist">
            <ion-item
              lines="none"
              class="description-item ion-text-wrap"
              text-wrap
            >
              <ion-label text-wrap>
                When enabled, users/groups added to the list below will
                <strong>always</strong> be treated as external customers in this
                channel, overriding all other classifications for them. If this
                list is empty, no users/groups are explicitly forced to be
                customers by this specific override (other rules still apply for
                others).
              </ion-label>
            </ion-item>
            <div class="chip-container">
              <ion-chip
                mode="ios"
                color="dark"
                class="add-chip"
                ngxTippy
                [hidden]="internalEntityOverrides?.blocklist?.length > 0"
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content:
                    'Unless users are specified, all users are considered customers'
                }"
              >
                <ion-label>Overriding all members as customers</ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                color="secondary"
                class="entity-chip"
                *ngFor="
                  let entity of internalEntityOverrides?.blocklist || [];
                  let i = index
                "
              >
                <ion-label> {{ getEntityName(entity) }} </ion-label>
                <ion-icon
                  name="close-circle"
                  (click)="removeFromBlocklist(i)"
                  aria-label="Remove from blocklist"
                ></ion-icon>
              </ion-chip>
              <ion-chip
                mode="ios"
                outline="true"
                color="secondary"
                (click)="addToBlocklist($event)"
                class="add-chip"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Add user or group to always treat as customer'
                }"
              >
                <ion-icon name="add-circle-outline" slot="start"></ion-icon>
                <ion-label>Choose specific users or groups</ion-label>
              </ion-chip>
            </div>
          </div>
        </ion-item-group>
      </ion-list>
      <div
        style="
          text-align: right;
          padding-top: 16px;
          padding-right: 8px;
          padding-bottom: 8px;
        "
      >
        <ion-button
          (click)="saveChannelSettings()"
          [disabled]="isSavingSettings || isLoading"
        >
          <ion-icon name="save" class="padded-icon"></ion-icon>
          Save Roles
          <ion-spinner
            *ngIf="isSavingSettings"
            name="dots"
            style="margin-left: 8px"
          ></ion-spinner>
        </ion-button>
      </div>
    </ion-card-content>
  </ion-card>
  <!-- End Specify Teammates and Customers Settings Card -->

  <!-- Channel Member List Card -->
  <ion-card class="outline-card">
    <div class="flex-space-between" style="padding: 15px 5px 0 3px">
      <div class="button-container">
        <ion-searchbar
          mode="ios"
          class="rounded-search-bar"
          placeholder="Search members..."
          showCancelButton="never"
          (ionChange)="reloadMembers()"
          [(ngModel)]="searchText"
        >
        </ion-searchbar>
        <div [hidden]="!selectedMembers.length">
          <ion-button (click)="sendMessage()" [disabled]="isLoading">
            <ion-icon name="mail-outline"></ion-icon>
            <span class="text-with-left-icon hidden-sm"> Send email </span>
          </ion-button>
          <ion-button
            fill="clear"
            color="dark"
            (click)="selectedMembers = []"
            [disabled]="isLoading"
          >
            Clear selection
          </ion-button>
        </div>
      </div>
      <div class="button-container" [hidden]="selectedMembers.length">
        <ion-button
          *ngIf="isSuperAdmin || isDev"
          fill="clear"
          color="dark"
          (click)="syncChannel()"
          [disabled]="isLoading"
          class="hidden-sm"
        >
          <ion-icon name="sync-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Sync Members </span>
        </ion-button>
        <ion-button
          fill="clear"
          color="dark"
          (click)="downloadMembers()"
          [disabled]="isLoading"
          class="hidden-sm"
        >
          <ion-icon name="cloud-download-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Download CSV </span>
        </ion-button>
        <ion-button
          fill="clear"
          color="dark"
          (click)="sendMessage()"
          [disabled]="isLoading"
        >
          <ion-icon name="mail-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Send email </span>
        </ion-button>
      </div>
    </div>
    <div style="padding: 5px 16px 0">
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'all' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'all' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'all'; reloadMembers()"
      >
        All
      </ion-button>
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'agents' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'agents' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'agents'; reloadMembers()"
      >
        Teammates
      </ion-button>
      <ion-button
        class="btn-small"
        [fill]="memberTypeFilter === 'customers' ? 'solid' : 'clear'"
        [color]="memberTypeFilter === 'customers' ? 'light' : 'dark'"
        (click)="memberTypeFilter = 'customers'; reloadMembers()"
      >
        Customers
      </ion-button>
    </div>

    <ngx-datatable
      class="material"
      [columnMode]="ColumnMode.force"
      [limit]="50"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [rows]="members"
      [selected]="selectedMembers"
      [selectionType]="SelectionType.checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      [reorderable]="true"
      (select)="onSelect($event)"
      paginated
      [dataSource]="membersDataSource"
      [loadingIndicator]="isLoading"
    >
      <ngx-datatable-column
        [width]="30"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="true"
        [checkboxable]="true"
      >
      </ngx-datatable-column>
      <ngx-datatable-column name="Name" [minWidth]="250" prop="user.name">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span>
            <a *ngIf="row.user?.name" (click)="viewProfile(row)">{{
              row.user?.name
            }}</a>
          </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Email" [minWidth]="250" prop="user.email">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <span> {{ row.user?.email }} </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        name="Role"
        [maxWidth]="170"
        [minWidth]="170"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="success" *ngIf="row.user?.isExternal"
            >Customer</ion-badge
          >
          <ion-badge
            color="dark"
            *ngIf="
              !row.user?.isExternal && !row.isExternal && isMemberAnAgent(row)
            "
          >
            Agent
          </ion-badge>
          <ion-badge
            color="dark"
            *ngIf="
              !row.user?.isExternal && !row.isExternal && !isMemberAnAgent(row)
            "
          >
            Teammate
          </ion-badge>
          <ion-badge
            color="success"
            *ngIf="!row.user?.isExternal && row.isExternal"
          >
            Internal Customer
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </ion-card>
</ion-content>
